import React, {forwardRef, useEffect, useState} from "react";
import axios from "axios";
import OrgBlock from "../components/OrganizationsPageComponents/OrgBlock";
import OrgBlockWithAddingPages from "../components/OrganizationsPageComponents/OrgBlockWithAddingPages";
import MoneyLeft from "../components/OrganizationsPageComponents/MoneyLeft";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ru} from "date-fns/esm/locale";
import {format} from "date-fns";
import MyPopUpForForms from "../components/MyPopUpForForms/MyPopUpForForms";
import MyUnderlinedBlock from "../components/MyUnderlinedBlock/MyUnderlinedBlock";
import JournalTable from "../components/OrganizationsPageComponents/JournalTable";
import OrganizationsWrapper from "../components/OrganizationsPageComponents/OrganizationsWrapper";

const Organizations = ({closeForm, setFormStatus, setIsSend}) => {
    const [organization, setOrganization] = useState([]);
    const [chosenOID, setChosenOID] = useState(null);
    const [organizationType, setOrganizationType] = useState([]);
    const [chosenOTID, setChosenOTID] = useState(null);
    const [currency, setCurrency] = useState([]);
    const [chosenCurrencyID, setChosenCurrencyID] = useState();
    const [chosenCurrency, setChosenCurrency] = useState();
    const [currencyID, setCurrencyId] = useState();
    const [reportYear, setReportYear] = useState("");
    const {format} = require("date-fns");
    const [date, setDate] = useState(null);
    const [formattedDate, setFormattedDate] = useState("");
    const [stipulatedSum, setStipulatedSum] = useState("");
    const [openingData, setOpeningData] = useState({
        sum: "0",
        balance: "0",
    });
    const [assessedData, setAssessedData] = useState({
        sum: "0",
        balance: "0",
    });
    const [restructingData, setRestructingData] = useState({
        sum: "0",
        balance: "0",
    });
    const [contributionPaymentsData, setContributionPaymentsData] = useState({
        sum: "0",
        balance: "0",
    });
    const [residueData, setResidueData] = useState({sum: "", balance: ""});
    const [sumSum, setSumm] = useState(0);
    let SS = 0;
    let [balanceSum, setBalanceSum] = useState(0);
    let bSum = 0;
    const [exchangeDifference, setExchangeDifference] = useState(0);

    const show_toaster = (message, status) => {
        let x = document.getElementById("snackbar");
        if (status === "success") {
            x.className = "show success";
            x.innerHTML = "Успешно!";
        } else if (status === "error") {
            x.className = "show error";
            x.innerHTML = "Ошибка!";
        }
        setTimeout(function () {
            x.className = x.className.replace("show", "");
        }, 3000);
    }

    const getOrgData = (id) => {
        axios
            .get(
                `${process.env.REACT_APP_API_LINK}/organization/?organization_type=${id}`,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                }
            )
            .then((res) => {
                setOrganization(res.data);
            });
    };
    const getValData = (id) => {
        axios
            .get(`${process.env.REACT_APP_API_LINK}/organization/${id}/`, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("accessToken"),
                },
            })
            .then((res) => {
                setCurrency(res.data.valutas);
            });
    };
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_LINK}/organization_type/`, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("accessToken"),
                },
            })
            .then((res) => {
                setOrganizationType(res.data);
            });
    }, []);

    const sendForm = (e) => {
        e.preventDefault();
        axios
            .post(
                `${process.env.REACT_APP_API_LINK}/organization_exchange_difference/`,
                {
                    opening_balance: openingData.balance,
                    opening_date: openingData.date,
                    opening_currency: openingData.currency,
                    opening_amount: openingData.sum,
                    assessed_contribution_payments: assessedData.array,
                    contribution_payments: contributionPaymentsData.array,
                    restructuring_payments: restructingData.array,
                    sum_in_soms_residue: Number.parseFloat(sumSum).toFixed(4),
                    residue_date: residueData.date,
                    residue_currency: residueData.price,
                    exchange_difference: Number.parseFloat(exchangeDifference).toFixed(4),
                    report_date: formattedDate,
                    reporting_year: reportYear,
                    stipulated_amount: stipulatedSum,
                    organization: chosenOID,
                    organization_valuta: currencyID,
                    sum_in_soms: Number.parseFloat(residueData.sum_in_soms).toFixed(4),
                    sum_amount: Number.parseFloat(balanceSum).toFixed(4),
                },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("accessToken"),
                    },
                }
            ).then(() => {
            show_toaster("Успешно!", "success");
            setIsSend(true)
        })
            .catch(() => {
                show_toaster("Ошибка!", "error");
                return;
            })
            .finally(() => {
                closeForm()

            })
        ;

    };

    useEffect(() => {
        getSumSum();
        setExchangeDifference(residueData.exchangeDifference);
    }, [
        openingData,
        assessedData,
        restructingData,
        contributionPaymentsData,
        residueData,
    ]);

    const getSumSum = () => {
        let datasSumValue = 0;
        let allDatasSum = 0;

        if (!isNaN(openingData.sum)) {
            datasSumValue += Number(openingData.sum);
        }
        if (!isNaN(assessedData.sum)) {
            datasSumValue += Number(assessedData.sum);
        }
        if (!isNaN(restructingData.sum)) {
            datasSumValue += Number(restructingData.sum);
        }
        if (!isNaN(contributionPaymentsData.sum)) {
            datasSumValue -= Number(contributionPaymentsData.sum);
        }

        // balance
        if (!isNaN(openingData.balance)) {
            allDatasSum += Number(openingData.balance);
        }
        if (!isNaN(assessedData.balance)) {
            allDatasSum += Number(assessedData.balance);
        }
        if (!isNaN(restructingData.balance)) {
            allDatasSum += Number(restructingData.balance);
        }
        if (!isNaN(contributionPaymentsData.balance)) {
            allDatasSum -= Number(contributionPaymentsData.balance);
        }
        if (
            contributionPaymentsData.sum === 0 ||
            openingData.sum === 0 ||
            assessedData.sum === 0 ||
            contributionPaymentsData.balance === 0 ||
            openingData.balance === 0 ||
            assessedData.balance === 0
        ) {
            setSumm(0);
        }
        setSumm(datasSumValue);
        SS = datasSumValue;
        setBalanceSum(allDatasSum);
        bSum = allDatasSum;
    };

    // ui
    const MyInputForDatePicker = forwardRef(
        ({onChange, placeholder, value, id, onClick}, ref) => (
            <input required={true}
                   onChange={
                       onChange
                   }
                   placeholder={placeholder}
                   value={value}
                   id={id}
                   onClick={onClick}
                   className="form-control text-dark text-center"
            />
        )
    );

    return (
        <React.Fragment>
            <form onSubmit={(e) => sendForm(e)}>
                <hr/>
                <br/>
                <div className="row">
                    <div className="col-4 col-md-3 text-center">
                        <p className="fs-5 mb-4">Тип организации</p>
                        <p className="fs-5 mb-4">Организация</p>
                        <p className="fs-5 mb-4">Валюта</p>
                        <p className="fs-5 mb-4">Отчетный год</p>
                        <p className="fs-5 mb-4">Предусмотренная сумма</p>
                    </div>
                    <div className="col-6 col-md-5">
                        <select required={true}
                                className="form-select mb-3"
                                onChange={(event) => {
                                    setChosenOTID(event.target.value);
                                    getOrgData(event.target.value);
                                }}
                        >
                            <option defaultValue value="">
                                Выбрать...
                            </option>
                            {organizationType.map((item, index) => (
                                <option key={index} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                        <select required={true}
                                disabled={chosenOTID === null}
                                className="form-select mb-3"
                                onChange={(event) => {
                                    setChosenOID(null);
                                    getValData(event.target.value);
                                    setChosenOID(event.target.value);
                                }}
                        >
                            <option defaultValue value="">
                                Выбрать...
                            </option>
                            {organization.map((item, index) => (
                                <option key={index} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>

                        <select required={true}
                                className="form-select mb-3"
                                onChange={(event) => {
                                    setChosenCurrencyID(JSON.parse(event.target.value).valuta.code);
                                    setChosenCurrency(event.target.value);
                                    setCurrencyId(JSON.parse(event.target.value).id);
                                }}
                                value={chosenCurrency}
                                disabled={chosenOID === null}
                        >
                            <option defaultValue value="">
                                Выбрать...
                            </option>
                            {currency.map((item, index) => (
                                <option key={index} value={JSON.stringify(item)}>
                                    {item.valuta.name} - {item.valuta.code}
                                </option>
                            ))}
                        </select>
                        <input required={true}
                               type="text"
                               className="form-control mb-3"
                               value={reportYear}
                               onChange={(event) => setReportYear(event.target.value)}
                               placeholder="Числовое значение"
                        />
                        <input required={true}
                               type="text"
                               className="form-control mb-3"
                               value={stipulatedSum}
                               onChange={(event) => setStipulatedSum(event.target.value)}
                               placeholder="Числовое значение"
                        />
                    </div>
                </div>
                <hr className="border border-dark border-1"/>
                <OrgBlock
                    blockData={setOpeningData}
                    chosenCurrencyID={chosenCurrencyID}
                    text="Остаток на начало года"
                />
                <hr className="border border-dark border-1"/>
                <OrgBlockWithAddingPages
                    setFourthBlockData={setAssessedData}
                    chosenCurrencyID={chosenCurrencyID}
                    text="Начисленные взносы"
                />
                <OrgBlockWithAddingPages
                    setFourthBlockData={setRestructingData}
                    chosenCurrencyID={chosenCurrencyID}
                    text="По графику реструктуризации"
                />
                <OrgBlockWithAddingPages
                    setFourthBlockData={setContributionPaymentsData}
                    chosenCurrencyID={chosenCurrencyID}
                    text="Оплата взноса"
                />
                <MoneyLeft
                    blockData={setResidueData}
                    b4={sumSum}
                    sumM={balanceSum}
                    text="Остаток"
                    chosenCurrencyID={chosenCurrencyID}
                />

                <hr className="border border-dark border-1"/>
                <MyUnderlinedBlock text="Курсовая разница" value={exchangeDifference}/>
                <hr className="border border-dark border-1"/>
                <div className="col-auto col-md-3 mb-3 d-grid gap-1">
                    <span>Дата</span>
                    <DatePicker
                        required={true}
                        selected={date}
                        closeOnScroll={true}
                        dateFormat="dd-MM-yyyy"
                        customInput={<MyInputForDatePicker/>}
                        locale={ru}
                        onChange={(date) => {
                            setDate(date);
                            setFormattedDate(format(date, "yyyy-MM-dd"));
                        }}
                    />
                </div>
                <hr className="border border-dark border-1"/>
                <div className="d-flex justify-content-end mt-3">
                    <button
                        type="submit"
                        className="btn btn-primary"
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal"
                    >
                        Отправить форму
                    </button>
                </div>
            </form>
        </React.Fragment>
    );
};

export default Organizations;
